// @ts-check

import React from "react";
import { Popconfirm, Input, Button } from "antd";
import { InfoCircleFilled, ReloadOutlined } from "@ant-design/icons";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const PostRegenerateEditor = ({ onConfirm, disabled }) => {
    const { t } = useTranslation();
    const [visible, setVisible] = useState(false);
    const [customPrompt, setCustomPrompt] = useState("");
    const handleConfirm = () => {
        onConfirm(customPrompt);
        setVisible(false);
        setCustomPrompt("");
    };

    return (
        <Popconfirm placement="top" title={t('postDistribution.regeneratePrompt')} description={<Input.TextArea rows={4} placeholder={t("postRegeneration.postRegenerationPlaceholder")} value={customPrompt} onChange={(e) => setCustomPrompt(e.target.value)} />} onConfirm={handleConfirm} onCancel={() => setVisible(false)} okText={t("functions.generate")} cancelText={t("functions.close")} icon={<InfoCircleFilled style={{ color: "blueviolet" }} />}>
            <Button className="post-content-button h-full"  disabled={disabled} onClick={() => setVisible(true)}>
                <ReloadOutlined />
                {t("posts.regenerate")}
            </Button>
        </Popconfirm>
    );
};

export default PostRegenerateEditor;
